import { createSlice } from "@reduxjs/toolkit";
import { TrackingSession, LocationPoint } from "../../../types/model/trackingSessionTypes";
import { fetchTrackingSessions, fetchSessionById, fetchLocationPoints } from "./api";

interface TrackingSessionsState {
  sessions: TrackingSession[];
  selectedSession: TrackingSession | null;
  locationPoints: LocationPoint[];
  loading: boolean;
  detailLoading: boolean;
  pointsLoading: boolean;
  error: string | null;
}

const initialState: TrackingSessionsState = {
  sessions: [],
  selectedSession: null,
  locationPoints: [],
  loading: false,
  detailLoading: false,
  pointsLoading: false,
  error: null,
};

export const TrackingSessionsSlice = createSlice({
  name: "trackingSessions",
  initialState,
  reducers: {
    clearSelectedSession(state) {
      state.selectedSession = null;
      state.locationPoints = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchTrackingSessions.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTrackingSessions.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.sessions = payload;
      })
      .addCase(fetchTrackingSessions.rejected, (state, { payload }) => {
        state.loading = false;
        state.error = payload || "Unknown error";
      });

    builder
      .addCase(fetchSessionById.pending, (state) => {
        state.detailLoading = true;
        state.error = null;
        state.selectedSession = null;
      })
      .addCase(fetchSessionById.fulfilled, (state, { payload }) => {
        state.detailLoading = false;
        state.selectedSession = payload;
      })
      .addCase(fetchSessionById.rejected, (state, { payload }) => {
        state.detailLoading = false;
        state.error = payload || "Unknown error";
      });

    builder
      .addCase(fetchLocationPoints.pending, (state) => {
        state.pointsLoading = true;
        state.error = null;
        state.locationPoints = [];
      })
      .addCase(fetchLocationPoints.fulfilled, (state, { payload }) => {
        state.pointsLoading = false;
        state.locationPoints = [...payload].sort((a, b) => a.timestamp - b.timestamp);
      })
      .addCase(fetchLocationPoints.rejected, (state, { payload }) => {
        state.pointsLoading = false;
        state.error = payload || "Unknown error";
      });
  },
});

export const { clearSelectedSession } = TrackingSessionsSlice.actions;
export default TrackingSessionsSlice.reducer;
